import React from 'react';
import T from 'prop-types';
import classnames from 'classnames';
import * as Classes from './styles.module.scss';

const Frame = ({
  frameName,
  frameThumbUrl,
  setFrameByName,
  handleDragStart,
  selected
}) => {
  const onClick = (e) => {
    e.preventDefault();
    setFrameByName(frameName);
  };

  const classname = classnames(
    Classes.frame, {
      [Classes.active]: selected
    }
  );

  return (
    <a
      href="#frame"
      role="button"
      onClick={ onClick }
      className={ classname }
      title={ frameName }
      onDragStart={ handleDragStart }
      onDragEnd={ handleDragStart }
    >
      <div className={ Classes.frameHolder }>
        <img src={ frameThumbUrl } alt={ frameName } />
      </div>
    </a>
  );
};

Frame.propTypes = {
  frameName: T.string.isRequired,
  frameThumbUrl: T.string.isRequired,
  setFrameByName: T.func.isRequired,
  handleDragStart: T.func.isRequired,
  selected: T.bool
};

export default Frame;
